import { Box, Grid, Link } from "@mui/material";
import PropTypes from "prop-types";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { applicantCountConstant } from "../../../config/constant";
import { useTranslation } from "react-i18next";

function AddAuthorizedSignatoryButton({
  title,
  applicantNo,
  applicantTotal,
  handleAddAuthorizedSignatory,
  type = "authorized", 
}) {
  const showButton = applicantNo === applicantTotal && applicantTotal < 4;
  const { t } = useTranslation();
  return (
    <>
      {showButton && (
        <Grid item xs={12} display="flex" justifyContent="center">
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            mt={5}
            sx={{
              border: "1px solid #1A407D",
              padding: "8px 20px",
              borderRadius: "8px",
            }}
          >
            <Link
              component="button"
              underline="none"
              color="#1A407D"
              fontWeight={600}
              fontSize="14px"
              onClick={handleAddAuthorizedSignatory}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                fontSize: "14px",
                // "&:hover": { color: "#062a73" },
              }}
            >
              <AddCircleOutlineIcon fontSize="small" />
              {type === "applicant" ? (
                <>
                  {t("commonLabels.add")}{" "}
                  <span>
                    {applicantNo + 1}
                    <sup style={{fontSize: "0.6em" }}>{applicantCountConstant?.numberKeys[applicantNo + 1]}</sup>
                  </span>{" "}
                  {t("commonLabels.applicant")}
                </>
              ) : (
                `${title} ${applicantNo + 1}`
              )}
            </Link>
          </Box>
        </Grid>

      )}
    </>
  );
}



AddAuthorizedSignatoryButton.propTypes = {
  applicantNo: PropTypes.any,
  applicantTotal: PropTypes.any,
  handleAddAuthorizedSignatory: PropTypes.any,
  title: PropTypes.any,
  type: PropTypes.any,
};

export default AddAuthorizedSignatoryButton;
